import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lightweight global event so the counter refreshes after a new waitlist signup
export const STATS_REFRESH_EVENT = "casa-haya-stats-refresh";

export function useFoundingStats() {
  const [stats, setStats] = useState({
    total: 0,
    founding_cap: 50,
    founding_remaining: 50,
    founding_full: false,
    loading: true,
  });

  const fetchStats = async () => {
    try {
      const { data } = await axios.get(`${API}/waitlist/stats`);
      setStats({ ...data, loading: false });
    } catch {
      setStats((s) => ({ ...s, loading: false }));
    }
  };

  useEffect(() => {
    fetchStats();
    const onRefresh = () => fetchStats();
    window.addEventListener(STATS_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(STATS_REFRESH_EVENT, onRefresh);
  }, []);

  return stats;
}
